export default __webpack_public_path__ + "static/media/A-L-Q.c89b33b4.png";